import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import { Theme } from "../../../..";
var loading = /*#__PURE__*/ keyframes("0%{left:50%;width:0;z-index:100;}33.3333%{left:0;width:100%;z-index:10;}100%{left:0;width:100%;z-index:1;}");
var LoadingIndicator = /*#__PURE__*/ styled("div", {
    target: "ej8cu6y0"
})("text-align:center;position:absolute;display:inline;width:0;top:0;height:2px;left:50%;background-color:", Theme.Color.primary, ";animation-name:", loading, ";animation-duration:2s;animation-timing-function:ease-in;animation-iteration-count:infinite;animation-delay:0.1s;&:first-of-type,&:last-child{background-color:", Theme.Color.natural70, ";}&.loading-indicator-top{top:0;}&.loading-indicator-bottom{bottom:0;}");
var Wrapper = /*#__PURE__*/ styled("div", {
    target: "ej8cu6y1"
})("width:100%;background-color:", Theme.Color.primary100, ";");
export { LoadingIndicator, Wrapper };
